export default __webpack_public_path__ + "static/media/pin-servis.74a9b8ed.svg";